import React, { useEffect } from "react";
import useAuthStore from "components/core/Auth/useAuthStore";
import useAuth from "components/core/Auth/useAuth.hooks";
import { useNavigate , useLocation } from "react-router-dom";

const Auth = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = window.localStorage.getItem("token");
  const outletId = window.localStorage.getItem("outlet_id");
  const redirectPath = location?.pathname || "/";

  useEffect(() => {
    if (!token) {
      navigate({ pathname: "/login", search: `?redirect=${redirectPath}` });
    } else if (!outletId) {
      // Token exists but no outlet mapped — user hasn't completed onboarding yet.
      navigate("/onboarding/form", { replace: true });
    }
  }, []);

  if (token && outletId) {
    return <>{children}</>;
  }
};

export default Auth;
